import React, { useState } from 'react';

const InputFile = ({ label, nameFile, onChange, requiredFile }) => {
	const [arquivo, setArquivo] = useState();
	const fileInput = React.createRef();

	const onChangeFile = async (e) => {
		e.preventDefault();
		if (e.target.files[0]) {
			setArquivo(e.target.files[0]);
			nameFile = e.target.name;
			onChange(e.target.files[0], nameFile);
		}
	};
	const removeFile = () => {
		setArquivo(undefined);
		fileInput.current.value = null;
		onChange(null);
	}

	return (
		<div className="field">
			<label className="label">{label}</label>
			<div className={`file has-name is-fullwidth ${arquivo && 'is-success'}`}>
				<label className="file-label">
					<input className="file-input" type="file" name={nameFile} ref={fileInput} onChange={onChangeFile} required={requiredFile} />
					<span className="file-cta">
						<span className="file-icon">
							<i className="fas fa-upload"></i>
						</span>
					</span>
					<span className="file-name">
						{arquivo ? arquivo.name : 'Escolha um arquivo...'}
					</span>
				</label>
			</div>
			{arquivo && <button className="button is-text help" onClick={removeFile}>remover arquivo</button>}
		</div>
	);
}

export default InputFile;